
let hostName = window.location.host;
hostName = hostName.split('.');

//export const IPUrl ="http://helpdesk.localhost";
// export const IPUrl ="http://127.0.0.1:8000";

//  Shirood and SorkhRoud and SalmanShahr and Amirkola
 export const IPUrl =`https://deskadmin.${hostName[1]}.${hostName[2]}/`;
 //export const IPUrl ="https://deskadmin.amirkola.ir/";
    //  AbbasAbad and Amol
   //  export const IPUrl =`https://desk.${hostName[1]}.${hostName[2]}/`;
    // SorkhRoud for test
   //export const IPUrl =`https://deskadmin.sorkhroud.ir/`;
  //export const IPUrl ="https://desk.myamol.ir/";
//export const IPUrl ="http://enc-pc:8080/";
// export const IPUrl = "https://desk.shahrdariabasabad.ir/";
    //  export const IPUrl ="http://192.168.100.9/";

